<template>
    <b-row :class="idx % 2 === 0 ? 'solution-main-light' : 'solution-main-dark'">
        <b-col align="left" class="instructions">
            <a :name="name" href="javascript:void(0)"
               v-on:click="showDialog('neka markdown vsebina')"><i
                    class="fas fa-question-circle myfas"></i>&nbsp;&nbsp;&nbsp; Kratka navodila</a>
        </b-col>
        <b-col align="right" class="categories">
          {{ categoriesText }}
            <span v-for="category in categories" v-bind:key="category.abbr">

                <popper
                    trigger="hover"
                    :options="{
                      placement: 'top',
                      modifiers: { offset: { offset: '0,10px' } }
                 }">

                  <div class="popper">
                      {{ category.name }}
                  </div>

                  <span slot="reference" class="category">
                        {{ category.abbr }}
                  </span>

                </popper>
            </span>
        </b-col>
    </b-row>
</template>

<script>
    import {pmisColorsMixin} from "../../mixins/pmis-colors-mixin";
    import presentation from "../../components/data/presentation.json";
    import Stackedit from 'stackedit-js';
    // import Stackedit from 'stackedit';

    export default {
        name: "PmisInfoFooterContainer",
        mixins: [pmisColorsMixin],
        props: {
            name: String,
            presentationMenu: Array,
            edit: Boolean,
            idx: Number,
            categories: Array
        },
        data() {
          return {
            stackEditText: null
          }
        },
        computed: {
          categoriesText() {
            switch (this.categories.length) {
              case 0:
                return "";
              case 1:
                return "Področje:";
              case 2:
                return "Področji:"
              default:
                return "Področja:"
            }
          }
        },
        methods: {
            showDialog(content) {
                if (this.stackEditText == null) {
                  content = "# Navodila\n Na tem mestu podajamo kratka navodila.\n\n# Video predstavitev\n Na tem mestu dodamo video predstavitev iz spletnega mesta.\n\n# Demo račun\n Tukaj so podane informacije od razpoložljivem demo računu.\n\n# Kreiranje računa\n Kratka navodila kako ustvariti nov uporabniški račun.\n\n# Primeri uporabe\n Praktično uporabe predstavljena čez primere uporabe\n\n# Namestitev v lastnem okolju\n Navodila kako rešitev namestiti v lastnem okolju.\n\n# Potrebna predznanja\n Tukaj navedemo vsa potrebna predznanja.";
                }
                else {
                  content = this.stackEditText;
                }
                if (!this.edit) {
                    content = presentation.hasOwnProperty(this.name) ? presentation[this.name].markdown :
                        JSON.parse(localStorage.getItem('new_solution'))[0].markdown;
                }

                try {
                    const el = document.querySelector('#makrdown-content');
                    el.value = content;
                    const stackedit = new Stackedit({
                        url: window._env_.STACKEDIT_URL + '/' + (this.edit ? "app" : "read")
                    });

                    stackedit.openFile({
                        name: 'Filename', // with a filename
                        content: {
                            text: el.value // and the Markdown content.
                        }
                    });

                    stackedit.on('fileChange', (file) => {
                        const editedText = file.content.text;
                        el.value = editedText;
                        this.stackEditText = editedText;
                    });
                } catch (err) {
                    console.log("Footer error: " + err);
                }

                // this.$modal.show('markdown-modal-dialog', content);
            }
        }
    }
</script>

<style lang="scss" scoped>
    a {
        color: white;
        text-decoration: none;
    }

    a:hover {
      color: yellow;
      text-decoration: none;
    }

    .instructions {
        font-weight: bold;
        margin-top: 3px;
        margin-left: 10px;
    }

    .categories {
      font-weight: bold;
      color: white;
      margin-top: 4px;
      margin-right: 10px;
    }

    .category {
      font-weight: normal;
      cursor: pointer;
    }

    /*.presentation-delimiter {*/
    /*    padding: 0px 10px;*/
    /*    color: white;*/
    /*}*/

    // v--modal-box v--modal vue-dialog
    .v--modal-overlay {
        backgound: $things-board-dark;
    }
</style>
